import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { StatisticsSummary } from '@routes/sidebar/___shared___/api/statistics.api.ts';
import { geApiStatistics } from '@routes/sidebar/___shared___/api/statistics.api.ts';
import { extractError } from '@utils/slice.ts';

interface StatisticsSlice {
    error: Record<string, any> | null;
    statisticsSummary: StatisticsSummary | null;
    isGetStatisticsPending: boolean;
}

const initialState: StatisticsSlice = {
    error: null,
    statisticsSummary: null,
    isGetStatisticsPending: false,
};

export const getStatistics = createAsyncThunk<StatisticsSummary, void, { rejectValue: any }>(
    'statistics/getStatistics',
    (_, { rejectWithValue }) =>
        geApiStatistics()
            .then((res) => res)
            .catch((err) => rejectWithValue(err)),
);

const statisticsSlice = createSlice({
    name: 'statistics',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getStatistics.pending, (state) => {
            state.error = null;
            state.isGetStatisticsPending = true;
        });

        builder.addCase(getStatistics.fulfilled, (state, action) => {
            state.statisticsSummary = action.payload;
            state.isGetStatisticsPending = false;
        });

        builder.addCase(getStatistics.rejected, (state, action) => {
            state.error = extractError(action);
            state.isGetStatisticsPending = false;
        });
    },
});

export default statisticsSlice.reducer;
